module.exports = __webpack_public_path__ + "static/media/gold_function.f9ec1389.svg";